import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Section, Loading, ErrorState, Empty } from "@/components/site/Primitives";
import { Showreel } from "@/components/site/Showreel";

export const FeaturedWork = ({ meta, index, site }) => {
  const [state, setState] = useState({ items: null, error: null });
  const reel = site?.showreel || { slots: 8, show_placeholders: true };
  const load = () => {
    setState({ items: null, error: null });
    api.get("/public/portfolio", { params: { homepage: true } })
      .then((r) => setState({ items: r.data, error: null }))
      .catch(() => setState({ items: [], error: "Couldn't load the portfolio." }));
  };
  useEffect(() => {
    load();
  }, []);
  const items = state.items;
  return (
    <Section id="portfolio" index={index} title={meta.title} subtitle={meta.subtitle}
      action={<Link to="/work" className="eb-btn-ghost" data-testid="view-all-work">View all work</Link>}>
      {state.error && <ErrorState message={state.error} onRetry={load} />}
      {!items && <Loading />}
      {items && !state.error && (items.length || reel.show_placeholders ? (
        <div className="-mx-5 sm:-mx-8 lg:-mx-12"><Showreel items={items} slots={reel.slots} placeholders={reel.show_placeholders} /></div>
      ) : (
        <Empty title="New work is being curated." body="Ask us for samples relevant to your brief.">
          <Link to="/enquire" className="eb-btn-ghost" data-testid="portfolio-empty-cta">Request relevant samples</Link>
        </Empty>
      ))}
    </Section>
  );
};
